import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utils from "@foxit/utils";
import protoUtils from "./utils/protoUtils.js";
import MetaInfo from "vue-meta-info";
import { signIn } from "@/utils/utils";

import "lib-flexible";

import { IAM_URL } from "const";

import "plu/useElement";
import "plu/useVant";
import "plu/useCommonComponent";
import "plu/echarts";

import "./assets/scss/web/element-variables.scss";

Vue.config.productionTip = false;

Vue.use(protoUtils);
Vue.use(MetaInfo);

Vue.prototype.utils = utils;

router.beforeEach((to, from, next) => {
  let url = window.location.href;
  if (process.env.NODE_ENV === "production" && url.indexOf("http:") >= 0) {
    url = url.replace("http", "https");
    window.location.replace(url);
    return;
  }
  // if (
  //   window?.readerCookies?.fid ||
  //   readerCookies.accessToken ||
  //   cloudCookies.accessToken
  // )
  //   return next();
  // if (
  //   !to.meta.auth &&
  //   !localStorage.getItem("token") &&
  //   readerCookies.accessToken &&
  //   cloudCookies.accessToken
  // ) {
  //   return signIn();
  // }
  return next();
});

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
